/**
 * Some default settings for the SDK
 */
const defaults = {
  maptilerApiURL: "https://api.maptiler.com/",
  mapStyle: "streets-v2",
};

Object.freeze(defaults);

export { defaults };
